import { CustomDataForm, MembershipCustomData } from './custom-data.types';

export const getCustomDataFormInitialValues = (data: MembershipCustomData): CustomDataForm => {
  const isEmptyObject =
    typeof data === 'object' &&
    data !== null &&
    !Array.isArray(data) &&
    Object.keys(data).length === 0;
  const isEmptyArray = Array.isArray(data) && data.length === 0;

  return {
    customData: !data || isEmptyObject || isEmptyArray ? '' : JSON.stringify(data, null, 2),
  };
};
